var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Card, Col, Spin, Table } from "antd";
import React, { useEffect, useState } from "react";
import { i18n } from "../../../../translations";
import { GroupAnalyticsNewTKeys } from "../../../../translations/keys";
var ViolationAndMachineTypeAnalyticsCard = function (props) {
    var _a = __read(useState(true), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(useState([]), 2), matrixTableData = _b[0], setMatrixTableData = _b[1];
    useEffect(function () {
        setLoading(true);
        setMatrixTableData(props.data);
        setLoading(false);
    }, [props.data]);
    return (React.createElement(Col, { span: 12 },
        React.createElement(Card, { headStyle: { fontSize: '16px' }, title: i18n.t(GroupAnalyticsNewTKeys.violationType), style: { height: "100%" }, bodyStyle: { padding: 0 } },
            React.createElement(Spin, { spinning: loading },
                React.createElement(Table, { dataSource: matrixTableData, rowKey: "key", bordered: true, size: "small", style: { borderRadius: 0 }, pagination: false },
                    React.createElement(Table.Column, { title: "Type", dataIndex: ["type"], render: function (text) {
                            return (React.createElement("span", { style: { textTransform: "capitalize" } }, text));
                        } }),
                    React.createElement(Table.Column, { title: i18n.t(GroupAnalyticsNewTKeys.geoAlerts), dataIndex: ["geoAlert"], sorter: true }),
                    React.createElement(Table.Column, { title: i18n.t(GroupAnalyticsNewTKeys.harshDriving), dataIndex: ["harshDriving"], sorter: true }),
                    React.createElement(Table.Column, { title: i18n.t(GroupAnalyticsNewTKeys.overspeed), dataIndex: ["overspeed"], sorter: true }),
                    React.createElement(Table.Column, { title: i18n.t(GroupAnalyticsNewTKeys.total), dataIndex: ["key"], sorter: true, render: function (text, record) {
                            var total = record.geoAlert +
                                record.harshDriving +
                                record.overspeed;
                            return React.createElement("span", null, total);
                        } }))))));
};
export default ViolationAndMachineTypeAnalyticsCard;
